/**
 * Defines the base route for the application.
 */
export const BASE_ROUTE = 'oryx.BaseRoute';
